import React from 'react'
import { Card, CardBody, CardTitle, Row, Col, Label } from "reactstrap"
import ParametrosHorasProyeccionRegimen from './ParametrosHorasProyeccionRegimen'
import { DetalleParametrosProyeccionHE } from '../TypesParametrosHorasExtras'

type PropsCardNroHorasProyeccion = {
    parametros: DetalleParametrosProyeccionHE | null | undefined,
}

export default function CardNroHorasProyeccion(props: PropsCardNroHorasProyeccion) {
    return (
        <Card>
            <CardTitle className="cardHeaderParametrosHoras" >
                <span className='pl-3'>
                    Número máximo de horas extras para proyección
                    <span className='pl-3'>
                        <i
                            className="fas fa-info-circle"

                        />
                    </span>

                </span>

            </CardTitle>
            <CardBody className="cardBodyNroHorasExtras">
                <Row>
                    <Col xl={6} className={"colParamNroHoras1"}>
                        <ParametrosHorasProyeccionRegimen
                            idRegimenLaboral={7}
                            nombreRegimen='LOSEP'
                            parametros={props.parametros?.listadoparametroshorasregimen}
                        />

                    </Col>
                    <Col xl={6} className={"colParamNroHoras2"}>
                        <ParametrosHorasProyeccionRegimen
                            idRegimenLaboral={9}
                            nombreRegimen='CÓDIGO DE TRABAJO'
                            parametros={props.parametros?.listadoparametroshorasregimen}
                        />
                    </Col>
                </Row>
            </CardBody>
        </Card>
    )
}
